import toastManager from "../toastManager";

// Detect celery progress
export const celeryStatusChecker = ({
  response,
  sanitizeCeleryResponse,
  setCalculationProgress,
  retryCeleryStatus,
  axiosFetch,
  celeryID,
}) => {
  if (response && response.state === "PENDING") {
    // Task is in pending to start
    const sanitizedCeleryResponse = sanitizeCeleryResponse({
      celeryProgressResponse: response,
    });
    setCalculationProgress(sanitizedCeleryResponse);
    retryCeleryStatus({ axiosFetch, celeryTaskId: celeryID });
  }

  if (response && response.state === "PROGRESS") {
    // Task is in progress
    const sanitizedCeleryResponse = sanitizeCeleryResponse({
      celeryProgressResponse: response,
    });
    setCalculationProgress(sanitizedCeleryResponse);
    retryCeleryStatus({ axiosFetch, celeryTaskId: celeryID });
  }

  if (response && response.state === "FAILURE") {
    // Task failed
    const sanitizedCeleryResponse = sanitizeCeleryResponse({
      celeryProgressResponse: response,
    });
    setCalculationProgress(sanitizedCeleryResponse);
    toastManager(
      "error",
      "Processing Error",
      "Issue processing task. Try different images, reload the page, or delete and re-create the entry."
    );
  }
};
